import {
  BasicMenu,
  BasicMenuItem,
} from '@client/new/components/BasicMenu/BasicMenu';
import { getCurrentPath } from '@client/helpers/routes';
import { PATHS } from '@client/routes';

import collectionIcon from '/static/images/collection-icon.svg';
import programIcon from '/static/images/program-icon.svg';
import uploadIcon from '/static/images/video-library-header.svg';

type CreateMenuProps = {
  creatorId: number;
  showUpload: boolean;
};

const toMenuItems = (
  creatorId: number,
  showUpload: boolean,
): BasicMenuItem[] => [
  {
    testId: 'programs-create-program',
    label: 'Program',
    url: PATHS.NEW_PROGRAM(creatorId, {
      from: getCurrentPath(true),
    }),
    icon: <img src={programIcon} alt="Program icon" />,
  },
  {
    testId: 'programs-create-category',
    label: 'Category',
    url: PATHS.NEW_CATEGORY(creatorId, {
      from: getCurrentPath(true),
    }),
    icon: <img src={collectionIcon} alt="Category icon" />,
  },
  ...(showUpload
    ? [
        {
          testId: 'programs-create-upload',
          label: 'Upload',
          url: PATHS.NEW_PROGRAM(creatorId, {
            from: getCurrentPath(true),
          }),
          icon: <img src={uploadIcon} alt="Upload icon" />,
        },
      ]
    : []),
];

export const CreateMenu = ({ creatorId, showUpload }: CreateMenuProps) => {
  return (
    <BasicMenu
      testId="programs-create-menu"
      title="Create"
      buttonColor="neutral"
      items={toMenuItems(creatorId, showUpload)}
    />
  );
};
